export const copy = (url: string) => {
	let dummy = document.createElement('textarea')
      document.body.appendChild(dummy)
      dummy.value = url
      dummy.select()
      document.execCommand('copy')
      document.body.removeChild(dummy)
}